import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable, Subject } from 'rxjs';

import { getLoggedIn, getProfile } from '../../../store/app.reducers';
import { Favourite } from '../../models';
import { getAllFavourites, getLoadingFavouriteFn, State } from '../../store';
import { SetFavourite, UnsetFavourite } from '../../store/items/items.actions';

import { map } from 'rxjs/operators';

@Component({
    selector: 'app-favourites-badge',
    templateUrl: './favourites-badge.component.html',
    styleUrls: ['./favourites-badge.component.scss']
})
export class FavouritesBadgeComponent implements OnInit, OnDestroy {

    private onDestroy$ = new Subject<void>();
    @Input() catalogueItemId: number;
    @Input() favouriteGroup = `${new Date().getUTCMilliseconds()}`; /* This variable is for protractor test to
   distinguish favourite icon in favourites list & other places (categories, cart)*/

    isLoggedIn$: Observable<boolean>;
    isLoading$: Observable<boolean>;
    favourite: Favourite;
    isFavourite$: Observable<number>;

    constructor(private store: Store<State>) {
    }

    ngOnInit() {
        this.isFavourite$ = this.store.pipe(
            select(getAllFavourites),
            map((favourites: Favourite[]) => {
                const temp = favourites.find(f => f.catalogueItemId === this.catalogueItemId);
                this.favourite = temp;
                return !!temp ? 1 : 0;
            })
        );

        this.isLoggedIn$ = this.store.pipe(select(getLoggedIn));

        this.isLoading$ = this.store.pipe(select(getLoadingFavouriteFn(this.catalogueItemId)));
    }

    ngOnDestroy() {
        this.onDestroy$.next();
    }

    onChangeFavourite(event) {
        if (!!event) {
            this.store.dispatch(new SetFavourite(this.catalogueItemId));
        } else {
            this.store.dispatch(new UnsetFavourite(this.favourite));
        }
    }
}
